import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['table-settings']);

export const tableSettingsQueryKeys = {
  forCommitee: (commiteeId: number | null) => builder('commitee', commiteeId ?? 'none'),
};
